import {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getBlogPosts} from "../../utils/firebase/firebase.utils";
import {isAdmin} from "../../utils/blog.constants";
import {UserContext} from "../../context/user.context";
import BlogCard from "../../components/blog-card/blog-card.component";
import "./blogging.styles.scss";

const Blogging = () => {
  const {currentUser} = useContext(UserContext);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const admin = isAdmin(currentUser);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const data = await getBlogPosts();
        setPosts(data);
      } catch (error) {
        console.error("Failed to load blog posts", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const [featured, ...rest] = posts;

  return (
    <div id="blogging" className="blogging">
      <div className="blog-container">
        <header className="blog-header">
          <p className="section-eyebrow">THE JOURNAL</p>
          <h1 className="blog-title">Thoughts, notes &amp; write-ups</h1>
          <p className="blog-subtitle">
            Writing about engineering, the things I build, and lessons picked
            up along the way.
          </p>

          {admin && (
            <Link to="/blog/new" className="blog-new-btn">
              + New Post
            </Link>
          )}
        </header>

        {loading ? (
          <p className="blog-status">Loading posts…</p>
        ) : posts.length === 0 ? (
          <div className="blog-empty">
            <p>No posts yet.</p>
            {admin && (
              <Link to="/blog/new" className="blog-new-btn">
                Write your first post
              </Link>
            )}
          </div>
        ) : (
          <>
            {featured && (
              <div className="blog-featured">
                <BlogCard post={featured} featured/>
              </div>
            )}

            {rest.length > 0 && (
              <div className="blog-grid">
                {rest.map((post) => (
                  <BlogCard key={post.id} post={post}/>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Blogging;
